import { createShapeNormalizer } from '@change-corgi/fcm/normalizers';

import { defineFcm } from '../shared/factory';

export const FCM_NEW_PETITION_PAGE_GOOGLE_ADDRESS_EXPERIMENT = defineFcm('new_petition_page_google_address_experiment')
	.asJson(
		createShapeNormalizer({
			type: 'object',
			optional: true,
			shape: {
				enabled: { type: 'boolean' },
				experimentName: { type: 'string', optional: true },
				localExperimentName: { type: 'string', optional: true },
			},
		}),
	)
	.withDefault({
		enabled: false,
		experimentName: undefined,
		localExperimentName: undefined,
	})
	.toConfig({
		owner: 'squad-capybara',
		scope: 'corgi-front-end',
		context: 'Petition Details',
		description: `Determines whether the new petition page Google address experiment is active and which experiment name to use:

		- If just "experimentName" is set, then one experiment is used with no geo-reach split.
		- If "localExperimentName" is set, then petitions with local geo-reach will use this experiment instead. The "experimentName" should also be set; it will be used for non-local petitions.

		The experiments with these names should be configured with the following variations:
		- optional - The address field will be shown but the form can be submitted with the field blank.
		- mandatory - The address field is shown and must be filled to submit the form.
		- control (default) - The address field is not shown.`,
		import: false,
		template: {
			enabled: false,
			experimentName: 'google_address_experiment',
			localExperimentName: 'google_address_experiment_local',
		},
		deprecated: 'FCM no longer in use — safe to delete after 2026-04-28',
	});
